import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../../../../cra/src/styling/breakpointsMinWidth';

const CategoryWrap = styled.div`
  grid-column: 1/-1;

  @media ${breakpointsMinWidth.tabletSm} {
    align-self: center;

    grid-row: 1;
    grid-column: 1 / span 3;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 1 / span 6;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    grid-column: 1 / span 7;
  }

  @media ${breakpointsMinWidth.desktopLg} {
    grid-column: 1 / span 6;
  }

  & div:last-child {
    margin: 0;
  }
`;

const CategoryBtn = styled.div`
  color: ${(props) => (props.active ? '#473880' : '#6c718b')};

  display: inline-block;

  font-size: 16px;
  font-weight: ${(props) => (props.active ? '700' : '400')};

  margin: 0 28px 0 0;

  cursor: pointer;
`;

const Categories = ({ activeCategory, data, changeCategory }) => (
  <CategoryWrap>
    {data.map((category) => (
      <CategoryBtn
        key={category.type}
        active={category.type === activeCategory}
        onMouseDown={() => changeCategory(category.type)}
      >
        {category.name}
      </CategoryBtn>
    ))}
  </CategoryWrap>
);

export default Categories;
